// Libraries
import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';
import styled from '@emotion/styled';

// MUI
import { Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Core
import { ResourceTextApplication } from '../../core/resources';

// Common
import ConfirmDeletionDialog from '../../common/dialog/ConfirmDeletionDialog';

// Interfaces
import { INotificationResult } from '../../interfaces/INotification';

// Store
// API
// Messaging
// Feature - Notifications
import { NotificationViewContext } from '../context/INotificationContext';

const StyledDeleteElement = styled(CloseIcon)(({ theme }) => ({
    cursor: 'pointer',
    textAlign: 'right',
    display: 'flex',
    justifyContent: 'right',
    marginLeft: 'auto',
    paddingRight: '5px',
}));

																									   
										
		
interface INotificationDeleteProps {
																								   
    notification: INotificationResult;
}

/** Display notification delete element. Call deleteNotification when delete element is clicked
 *
 * @props notification: INotification
 * @props deleteNotification: (id: string) => void
 */

																									   
																								
		
export default function NotificationDelete({ notification }: INotificationDeleteProps) {
																								   
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral']);

    const { deleteNotification } = useContext(NotificationViewContext);

    const [confirmDialogVisible, setConfirmDialogVisible] = useState<boolean>(false);

    return (
        <>
            <Tooltip title={t('AnelmaGeneral:1012')} placement='top-start'>
                <StyledDeleteElement onClick={() => setConfirmDialogVisible(true)} />
            </Tooltip>

            <ConfirmDeletionDialog
                open={confirmDialogVisible}
                onClose={() => setConfirmDialogVisible(false)}
                onDelete={() => deleteNotification(notification)}
                confirmation={t('AnelmaGeneral:1142')}
            />
        </>
    );
}
